import { render } from "./ClaimBlocs.vue?vue&type=template&id=9c09151c&scoped=true"
import script from "./ClaimBlocs.vue?vue&type=script&lang=js"
export * from "./ClaimBlocs.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pmattern/Documents/3 - GIT/studio-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c09151c"]])

export default __exports__